import { defaultColor, listColors } from './collaboration.config';
import { SocketId, SocketUser, SocketUserMap, UserData } from './collaboration.types';

/**
 * Create a new Collaboration store instance
 *
 * @returns {CollaborationStore}
 */
export const createCollaborationStore = () => new CollaborationStore();

export default class CollaborationStore {
  state: { editors: SocketUserMap };
  colors: { [key: string]: string };

  constructor() {
    this.state = {
      editors: {},
    };
    // create the ordered colors bucket
    this.colors = listColors.reduce((result, color, i) => Object.assign(result, { [i]: color }), {});
  }

  /**
   * Add User to state and randomly assign him a color
   * @param {object} data
   * @returns {object} socketUser
   */
  addSocketUser(data: UserData): SocketUser {
    const socket: SocketUserMap = {};
    const { socketId, user_id, user_first_name, user_last_name, page_id, speaker_notes } = data;
    let selected = [];
    if (data.selected) {
      selected = Array.isArray(data.selected) ? data.selected : JSON.parse(data.selected || '[]');
    }
    const colorsKeys = Object.keys(this.colors);
    let colorKey = null;
    let color = defaultColor;
    if (colorsKeys.length > 0) {
      // get the first color of the bucket
      colorKey = colorsKeys[0];
      color = this.colors[colorKey];
      // remove from bucket
      delete this.colors[colorKey];
    }
    socket[socketId] = {
      socketId,
      userId: user_id,
      name: user_last_name,
      firstname: user_first_name,
      color,
      colorKey,
      selected,
      pageId: page_id || null,
      speakerNotes: speaker_notes || null,
    };
    Object.assign(this.state.editors, socket);

    return this.state.editors[socketId];
  }

  /**
   * Remove User and release the assigned class
   * @param {object} socketUser
   */
  removeSocketUser(socketUser: SocketUser) {
    const { color, colorKey, socketId } = socketUser;
    const currentState = this.state.editors;
    // put back the color in the bucket and keep the original order
    if (colorKey) {
      this.colors[colorKey] = color;
    }
    // Updade state
    const newState = Object.keys(currentState).reduce((object: { [key: string]: SocketUser }, key) => {
      if (key !== socketId) {
        object[key] = currentState[key];
      }
      return object;
    }, {});
    this.state.editors = newState;
  }

  /**
   * Get User object from socket id
   * @param {string} socketId
   * @returns {Object}
   */
  getSocketUser(socketId: SocketId) {
    if (this.state.editors[socketId]) {
      return this.state.editors[socketId];
    }
  }

  /**
   * Get all socket Users
   * @returns {Object}
   */
  getSocketUsers() {
    return this.state.editors;
  }

  /**
   * Check if there's at least another editor
   * @returns {Boolean}
   */
  hasSocketUsers() {
    const users = this.getSocketUsers();
    return !!users && typeof users === 'object' && Object.keys(users).length > 0;
  }
}
